const shared = {
  home: "Home",
  language: "Ar",
  admins: "Admins",
  addAdmin: "Add admins",
  lookups: "Lookups",
  serviceProviderSubCategories: "Service provider sub categories",
  serviceProviders: "Service providers",
  specialties: "Specialties",
  services: "Services",
  logout: "Logout",
  lang: "العربية",
  back: "Back",
  noSearch: "There are no results matching your search",
  noData: "There are no data yet",
  actions: "Actions",
  edit: "Edit",
  view: "View",
  delete: "Delete",
  save: "Save",
  submit: "Submit",
  cancel: "Cancel",
  apply: "Apply",
  filter: "Filter",
  confirm: "Confirm",
  myAccount: "My Account",
  navbarTitle: "Welcome to Ex-Gates seamless trade across borders",
  copyrights: "©2024 ExGates  |  All Rights Reserved",
  filters: "Filters",
  clearFilters: "Clear Filters",
  deactivate: "Deactivate",
  reactivate: "Reactivate",
  add: "Add",
  lists: {
    enTitle: "Title (En)",
    arTitle: "Title (Ar)",
    enName: "Name (En)",
    arName: "Name (Ar)",
    name: "Name",
    email: "Email",
    phone: "Phone Number",
    image: "Image",
    subCategories: "Sub Categories",
    status: "Status"
  },
  filesAccepted:
    "Max size: 2MB, accepted formats: jpg, jpeg, png, and bmp",
  uploadTypeError:
    "Accepted formats are jpg, jpeg, png, and bmp only",
  uploadSizeError: "Max size is 2MB",
  acceptedFormatLabel: "Accepted format",
  noOptions: "No options",
  to: "To",
  from: "From",
  done: "Done",
  sortBy: "Sort by",
  loadMore: "Load More",
  piece: "Piece",
  ok: "Ok",
  filtersDrawerLabels: {
    viewMore: "View More",
    viewLess: "View Less",
    noResultsFound: "No filters found",
    dateRange: "Request Date Range"
  },
  sideMenu: {
    products: "Products",
    categories: "Categories",
    approvedList: "Approved List",
    requestsList: "Requests List",
    subCategories: "Sub Categories",
    users: "Users",
    importersList: "Importers List",
    exportersList: "Exporters List",
    combinedList: "Combined List",
    verificationSubscription: "Verifications & Subscriptions",
    verificationList: "Verification List",
    vouchers: "Vouchers",
    transactions: "Transactions",
    employees: "Employees",
    employeesList: "Employees List",
    roles: "Roles & Permissions"
  },
  upload: {
    mainText: "Click here to upload an image",
    validationText: "JPG, PNG, JPEG or Bmp file size no more than 2MB"
  },

  internetConnection: "No Internet Connection",
  generalErrMsg: "Sorry, Something Went Wrong",
  errSettingNotifications:
    "Sorry, there was an error setting up notifications",
  askForNotificationsPermission:
    "For notifications to work, kindly enable notifications permission on your browser",
  auth: {
    welcomeTitle: "Welcome Back!",
    welcomeMsg: "Welcome to Ex-Gates seamless trade across borders"
  },
  hi: "Hi",
  cropImg: "Crop Image",
  accept: "Accept",
  reject: "Reject",
  approve: "Approve",
  profileImg: "Profile-img",
  noSearchResults:
    "There is no search result or filter result that matches the entered data.",
  browseFiles: "Browse Files",
  send: "Send",
  clickToView: "Click to view",
  downloadImage: "Download Image",
  notFound: {
    goBack: "Go Back",
    sorry: "SORRY!",
    noPermission: "you do not have permission to access this page."
  },
  password: {
    setANewPassword: "Set a new password",
    labels: {
      newPassword: "New Password",
      confirmPassword: "Confirm Password"
    },
    placeholders: {
      enterYourPassword: "Enter your password"
    },
    resetPasswordBtn: "Reset Password"
  },
  passwordValidations: {
    passwordConditions: "Your password must contain",
    eightCharacters: "Minimum 8 characters",
    oneUpper: "Contains uppercase characters",
    oneLower: "Contains lowercase characters",
    numbersAndSpecial: "Contains numbers and symbols"
  },
  optional: "(Optional)"
};

export default shared;
